import {
  COMMON_STYLES,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from '@dehaat/dds'
import React from 'react'
import { View, Text } from 'react-native'

interface Props {
  label: string
  value?: string | null
  labelColumnWidth?: number
}

const RecordRow = ({ label, value, labelColumnWidth = 120 }: Props) => {
  return (
    <View style={[COMMON_STYLES.row, COMMON_STYLES.fullWidth]}>
      <Text
        style={[
          TYPOGRAPHY.TEXT2,
          VARIANTS_STYLES.MEDIUM,
          TEXT_STYLES.textNeutral70,
          { width: labelColumnWidth },
        ]}
      >
        {label}:
      </Text>
      <Text
        style={[
          TYPOGRAPHY.TEXT2,
          VARIANTS_STYLES.MEDIUM,
          TEXT_STYLES.textNeutral70,
          COMMON_STYLES['ml0.5'],
          COMMON_STYLES.flex1,
        ]}
      >
        {value || '--'}
      </Text>
    </View>
  )
}

export default RecordRow
